/**
 * Magolt pszeudovéletlen generátor (mulberry32).
 * A kódbázisban `Math.random()` használata TILOS — minden véletlen innen jön,
 * hogy a szimuláció reprodukálható és tesztelhető legyen.
 * Gazda: C
 */

export class Rng {
  private state: number

  constructor(seed: number) {
    // A 0 mag degenerált sorozatot adna, ezért eltoljuk.
    this.state = (seed | 0) === 0 ? 0x9e3779b9 : seed | 0
  }

  /** [0, 1) */
  next(): number {
    this.state = (this.state + 0x6d2b79f5) | 0
    let t = this.state
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }

  /** [min, max) */
  range(min: number, max: number): number {
    return min + this.next() * (max - min)
  }

  /** [min, max] egész, mindkét vég zárva. */
  int(min: number, max: number): number {
    return Math.floor(min + this.next() * (max - min + 1))
  }

  /** true `p` valószínűséggel (p: 0..1). */
  chance(p: number): boolean {
    return this.next() < p
  }

  pick<T>(arr: readonly T[]): T {
    return arr[Math.floor(this.next() * arr.length)]
  }

  /** Előjeles szórás: [-spread, +spread] */
  spread(s: number): number {
    return (this.next() * 2 - 1) * s
  }

  /**
   * Doom-szerű sebzésdobás: több kis dobás összege, így haranggörbét ad
   * egyenletes eloszlás helyett — kiszámíthatóbb, kevésbé frusztráló.
   */
  damage(min: number, max: number, dice = 3): number {
    const span = max - min
    let sum = 0
    for (let i = 0; i < dice; i++) sum += this.next()
    return Math.round(min + (sum / dice) * span)
  }

  fork(salt: number): Rng {
    return new Rng((this.state ^ Math.imul(salt, 0x85ebca6b)) | 0)
  }
}

/** Determinisztikus, nem-szimulációs célú generátor (textúrák, modellek). */
export function seededRng(seed: number): Rng {
  return new Rng(seed)
}
